export class ICubismModelSetting {
}
import * as $ from './icubismmodelsetting';
export var Live2DCubismFramework;
(function (Live2DCubismFramework) {
    Live2DCubismFramework.ICubismModelSetting = $.ICubismModelSetting;
})(Live2DCubismFramework || (Live2DCubismFramework = {}));
